export const GET_ABOUT_US = "GET_ABOUT_US";
export const GET_FOOTER_DATA = "GET_FOOTER_DATA";
export const GET_CANCEL_POLICY = "GET_CANCEL_POLICY";
export const GET_PRIVACY_POLICY = "GET_PRIVACY_POLICY";
export const GET_TERM_CONDITION = "GET_TERM_CONDITION";
